import React, { useState } from "react";
import {
  CardContent,
  Checkbox,
  FormControlLabel,
  Box,
  Tab,
} from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useTranslation } from "react-i18next";

import RoutePaths from "routes/RoutePaths";
import { setPointsPlaneToPurchase } from "redux/reducers/purchaseSlice";
import { useAppDispatch } from "redux/store/hooks";
import { Card } from "components/Shared/Card";
import { Button } from "../Shared/Button";
import PurchaseArea from "./purchaseArea";
import PurchasePointsTable from "./purchasePointsTable";
import PurchasePointsHistory from "./PurchasePointsHistory";
import { check } from "assets/images";
import "./styles.scss";
import usePurchaseSelector from "redux/selectors/purchaseSelectors";

enum PurchaseStep {
  Table = 1,
  CardInfo = 2,
  Success = 3,
}
interface LocationState {
  from?: Location;
  id: any;
}

const PurchasePoints = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { pointsPlanToPurchase } = usePurchaseSelector();
  const [isAgree, setIsAgree] = useState<boolean>(false);
  const [value, setValue] = useState("1");
  const [setp, setStep] = useState<PurchaseStep>(PurchaseStep.Table);
  const location = useLocation();
  const history = useHistory();

  const handleOnClickPurchase = () => {
    if (!isAgree || !pointsPlanToPurchase) {
      return;
    }
    setStep(PurchaseStep.CardInfo);
  };

  const handleOnSuccessfulCheckout = () => {
    setStep(PurchaseStep.Success);
    dispatch(setPointsPlaneToPurchase(null));
  };

  const handleClose = () => {
    setStep(PurchaseStep.Table);
    setIsAgree(false);
    dispatch(setPointsPlaneToPurchase(null));
  };

  const state = location.state as LocationState;

  const handleBackToLesson = () => {
    if (state?.from) {
      history.push({
        pathname: RoutePaths.lessonPreview,
        search: `?id=${state.id}`,
      });
    } else {
      history.push(RoutePaths.root);
    }
  };
  const renderContent = () => {
    switch (setp) {
      case PurchaseStep.Table:
        return (
          <div>
            <TabContext value={value}>
              <Box>
                <TabList
                  onChange={(e, tab) => setValue(tab)}
                  aria-label="lab API tabs example"
                  className="tab_items"
                >
                  <Tab
                    label={t("studentPurchasePoints.tabs.purchasePoints")}
                    value="1"
                    className="tab_item"
                  />
                  <Tab
                    label={t(
                      "studentPurchasePoints.tabs.purchasePointsHistory"
                    )}
                    value="2"
                    className="tab_item"
                  />
                </TabList>
              </Box>
              <TabPanel value="1" className="tab-panel">
                <Card>
                  <CardContent className="card-content">
                    <PurchasePointsTable />
                    <div className="purchase_button_area">
                      <FormControlLabel
                        className="check_area"
                        name={"terms-and-conditions"}
                        control={<Checkbox />}
                        onChange={(event, checked) => setIsAgree(checked)}
                        checked={isAgree}
                        label={
                          <span className="service-agreement">
                            <a href={RoutePaths.termsOfService} target="_blank">
                              {t("expertProfile.application.label.tnc")}
                            </a>
                            <>{` `}</>
                            <a href={RoutePaths.privacyPolicy} target="_blank">
                              {t(
                                "expertProfile.application.label.privacy_policy"
                              )}
                            </a>
                            <>{`  ${t(
                              "purchasePoints.serviceAgreement.content"
                            )}`}</>
                          </span>
                        }
                      />
                    </div>
                    <Button
                      label={t("purchasePoints.label.purchaseButton")}
                      customStyles={
                        !isAgree || !pointsPlanToPurchase
                          ? "magenta disabled"
                          : "magenta"
                      }
                      disabled={!isAgree || !pointsPlanToPurchase}
                      onClick={() => handleOnClickPurchase()}
                    />
                  </CardContent>
                </Card>
              </TabPanel>
              <TabPanel value="2" className="tab-panel">
                <PurchasePointsHistory />
              </TabPanel>
            </TabContext>
          </div>
        );
      case PurchaseStep.CardInfo:
        return (
          <div>
            <PurchaseArea
              handleOnSuccessfulCheckout={handleOnSuccessfulCheckout}
              handleClose={() => handleClose()}
            />
          </div>
        );
      case PurchaseStep.Success:
        return (
          <div className="purchase_points_success">
            <Card>
              <CardContent className="card-contents">
                <img src={check} alt="" className="check-img" />
                <div className="card-title">
                  {t("purchasePoints.label.successMessage")}
                </div>
                <div className="btn-area">
                  <Button
                    customStyles="gray"
                    variant="outlined"
                    label={t("purchasePoints.label.close")}
                    onClick={() => handleClose()}
                  />
                  <Button
                    customStyles="magenta"
                    variant="outlined"
                    label={
                      state?.from
                        ? t("purchasePoints.label.reservationPage")
                        : t("purchasePoints.label.backToTopPage")
                    }
                    onClick={handleBackToLesson}
                  />
                </div>
              </CardContent>
            </Card>
          </div>
        );
      default:
        return null;
    }
  };
  return <div className="purchase_points">{renderContent()}</div>;
};

export default PurchasePoints;
